import { useState } from 'react';
import { TaskPage } from '../../../components/workbook/TaskPage';
import { TextInput, Checkbox } from '../../../components/workbook/forms';
import { Callout } from '../../../components/workbook/Callout';

export default function SignoffRetrievalPage() {
  const [owners, setOwners] = useState('');
  const [date, setDate] = useState('');
  const [nextReview, setNextReview] = useState('');
  const [nowSlice1, setNowSlice1] = useState('');
  const [doneMeaning, setDoneMeaning] = useState('');
  const [cutItem, setCutItem] = useState('');
  const [stopCondition, setStopCondition] = useState('');
  const [weeklyReviewOnCalendar, setWeeklyReviewOnCalendar] = useState(false);

  return (
    <TaskPage
      phase="prioritize"
      title="Sign-off & Retrieval"
      pageNumber={8}
      instruction="Make it stick. Sign off on the plan, publish it, and do a 3-minute recall. Publish: link to doc/board; notify stakeholders."
      whyItMatters="Quick retrieval + scheduled reviews produce durable learning and follow-through, not just a plan on paper."
      coachRail={{
        timing: "3-5 minutes",
        tips: "Publish the plan. Share with stakeholders. Set review dates.",
        debrief: "Weekly review is on the calendar ☐"
      }}
    >
      <div className="space-y-6">
        <div className="bg-[var(--surface)] p-6">
          <h3 className="text-lg font-semibold text-[var(--text-pri)] mb-4">Sign-off</h3>
          <div className="grid grid-cols-3 gap-4">
            <TextInput
              label="Owners"
              value={owners}
              onChange={(e) => setOwners(e.target.value)}
              placeholder="Who's signing off?"
            />
            <TextInput
              label="Date"
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <TextInput
              label="Next review"
              type="date"
              value={nextReview}
              onChange={(e) => setNextReview(e.target.value)}
            />
          </div>
          <div className="mt-4 bg-[var(--slate-dim)] border border-[var(--slate)] p-4">
            <p className="text-sm text-[var(--text-sec)]">
              <strong>Publish:</strong> link to doc/board; notify stakeholders.
            </p>
          </div>
        </div>

        <div className="bg-[var(--green-dim)] border border-[var(--green)] p-6">
          <h3 className="text-lg font-semibold text-[var(--green)] dark:text-[var(--text-ter)] mb-4">3-minute Recall</h3>
          <div className="space-y-4">
            <div>
              <TextInput
                label="Our #1 Now slice is"
                value={nowSlice1}
                onChange={(e) => setNowSlice1(e.target.value)}
                placeholder="What's the top priority?"
                className="mb-2"
              />
              <TextInput
                label="and 'done' means"
                value={doneMeaning}
                onChange={(e) => setDoneMeaning(e.target.value)}
                placeholder="What does done mean?"
              />
            </div>
            <TextInput
              label="One thing we cut (and why) is"
              value={cutItem}
              onChange={(e) => setCutItem(e.target.value)}
              placeholder="What did we cut and why?"
            />
            <TextInput
              label="The stop-condition we'll watch first is"
              value={stopCondition}
              onChange={(e) => setStopCondition(e.target.value)}
              placeholder="What would make us stop?"
            />
            <label className="flex items-center gap-3 cursor-pointer">
              <Checkbox
                checked={weeklyReviewOnCalendar}
                onChange={(e) => setWeeklyReviewOnCalendar(e.target.checked)}
                label="Weekly review is on the calendar"
              />
            </label>
          </div>
        </div>

        <Callout type="tip" phase="prioritize">
          <p className="text-sm">Quick retrieval + scheduled reviews produce durable learning and follow-through, not just a plan on paper.</p>
        </Callout>
      </div>
    </TaskPage>
  );
}






